class ReservationFormBuilder {
  constructor(target) {
    this.reservationForm = target;

    this.reservingCompanyButtons = this.reservationForm.find('input:radio[name="reservation[reserving_company]"]');
    this.reservingCompanySection = this.reservationForm.find('#section_reserving_company');
    this.reservingPersonsSection = this.reservationForm.find('#section_persons_reserving');

    this.secondReservingButtons = this.reservationForm.find('input:radio[name="reservation[second_reserving]"]');
    this.secondReservingSection = this.reservationForm.find('#section_second_reserving');

    this.usesCreditCheckbox = this.reservationForm.find('input#reservation_uses_credit');
    this.usesCreditSection = this.reservationForm.find('#section_uses_credit');
  }

  setup() {
    this.updateReservingCompanySection();
    this.reservingCompanyButtons.on('change', (e) => this.updateReservingCompanySection());

    this.updateSecondReservingSection();
    this.secondReservingButtons.on('change', (e) => this.updateSecondReservingSection());

    this.updateUsesCreditSection();
    this.usesCreditCheckbox.on('change', (e) => this.updateUsesCreditSection());
  }

  updateReservingCompanySection() {
    var displayReservingCompany = (this.reservingCompanyButtons.filter(':checked').val() === 'true');

    if (displayReservingCompany)
    {
      this.reservingCompanySection.show();
      this.reservingPersonsSection.hide();
    }
    else
    {
      this.reservingCompanySection.hide();
      this.reservingPersonsSection.show();
    }
  }

  updateSecondReservingSection() {
    var displaySecondReserving = (this.secondReservingButtons.filter(':checked').val() === 'true');

    if (displaySecondReserving)
    {
      this.secondReservingSection.show();
    }
    else
    {
      this.secondReservingSection.hide();
    }
  }

  updateUsesCreditSection() {
    var displayUsesCredit = this.usesCreditCheckbox.is(":checked");

    if (displayUsesCredit)
    {
      this.usesCreditSection.show();
    }
    else
    {
      this.usesCreditSection.hide();
    }
  }
}

var buildReservationForm = function () {
  var builder = new ReservationFormBuilder($(this));

  builder.setup();

  return builder;
};

export default buildReservationForm;
